var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@storeblocks/button';
import LoadingIndicator from '@storeblocks/loading-indicator';
import { Icon } from '@storeblocks/icon';
import { getText } from '@storebrand-digital/fms-translations';
import IconButton from '../../../../components/IconButton';
import FileUpload from '../../../../components/FileUpload';
import FileList from '../../../../components/FileList';
import Textarea from '../../../../components/Textarea';
import ErrorComponent from '../../../../components/ErrorComponent';
import { ButtonWrap, Wrap, ErrorWrap, TextareaWrap } from './styled';
import { useModalContext } from '../../../../components/Context';
import { createMessageThreadRequested } from '../../redux/threadSlice';
function Description(_a) {
    var _this = this;
    var confirmClose = _a.confirmClose, label = _a.label, payload = _a.payload, trackId = _a.trackId, closeModal = _a.closeModal, setConfirmClose = _a.setConfirmClose;
    var dispatch = useDispatch();
    var _b = useModalContext(), setHeading = _b.setHeading, setFooter = _b.setFooter;
    var _c = useState(''), message = _c[0], setMessage = _c[1];
    var _d = useState(true), filesValid = _d[0], setFilesValid = _d[1];
    var _e = useState([]), files = _e[0], setFiles = _e[1];
    var _f = useState(false), slow = _f[0], setSlow = _f[1];
    var timer = useRef(null);
    var _g = useSelector(function (state) { return state.messageThreads.createMessageThreadState; }), loading = _g.loading, success = _g.success, error = _g.error;
    var isFramMember = useSelector(function (state) { return state.messageThreads; }).isFramMember;
    useEffect(function () {
        if (confirmClose && message === '' && files.length === 0) {
            closeModal();
        }
    }, [confirmClose]);
    useEffect(function () {
        setHeading(label);
        if (loading || success) {
            setFooter(null);
        }
        else if (confirmClose) {
            setFooter(React.createElement(React.Fragment, null,
                React.createElement(Button, { onClick: function () { return setConfirmClose(false); }, mr: "16px", "data-trackid": "button-".concat(trackId, "_abort_cancel|").concat(getText('compose.confirm.abort.label')) }, getText('compose.confirm.abort.label')),
                React.createElement(Button, { variant: "outlined", onClick: closeModal, "data-trackid": "button-".concat(trackId, "_abort_confirm|").concat(getText('compose.confirm.close.label')) }, getText('compose.confirm.close.label'))));
        }
        else {
            setFooter(React.createElement(ButtonWrap, null,
                React.createElement(FileUpload, { id: "attachments", label: getText('compose.description.files.label'), trackId: trackId, onUploadFile: onUploadFile }),
                React.createElement(IconButton, { active: message !== '', onClick: onSave, iconRight: "arrow-right", "data-trackid": "button-".concat(trackId, "_send_message|").concat(getText('compose.description.submit.label')) }, getText('compose.description.submit.label'))));
        }
    }, [
        setHeading,
        setFooter,
        loading,
        message,
        success,
        confirmClose,
        files,
        error,
        filesValid,
    ]);
    useEffect(function () { return function () { return clearTimeout(timer.current); }; }, []);
    var onChange = function (e) {
        setMessage(e.target.value);
    };
    var onUploadFile = function (uploaded) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setFiles(__spreadArray(__spreadArray([], files, true), uploaded, true));
            return [2 /*return*/];
        });
    }); };
    var onRemoveFile = function (updatedFiles) {
        setFiles(updatedFiles);
    };
    var onSave = function () {
        if (filesValid && (message !== '' || files.length !== 0)) {
            dispatch(createMessageThreadRequested(__assign({ category: payload.category, description: message, fileInfo: files }, payload)));
            timer.current = setTimeout(function () {
                setSlow(true);
            }, 3000);
        }
    };
    if (loading) {
        return (React.createElement(Wrap, null,
            React.createElement(LoadingIndicator, null),
            slow ? (React.createElement("p", null, getText('compose.loading.slow.description'))) : (React.createElement("p", null, getText('compose.loading.description')))));
    }
    if (success) {
        return (React.createElement(Wrap, null,
            React.createElement(Icon, { name: "thumbs-up" }),
            isFramMember ? (React.createElement("p", null, getText('compose.sent.framMember.description'))) : (React.createElement("p", null, getText('compose.sent.description'))),
            React.createElement("div", { id: "secure-message-feedback" })));
    }
    if (confirmClose) {
        return React.createElement("p", null, getText('compose.confirm.description'));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(TextareaWrap, null,
            React.createElement(Textarea, { id: "description", name: "description", value: message, onChange: onChange })),
        error && (React.createElement(ErrorWrap, null,
            React.createElement(ErrorComponent, { isCompose: true, error: error }))),
        files.length > 0 && (React.createElement(FileList, { files: files, onRemoveFile: onRemoveFile, setIsValid: setFilesValid, isRedBackground: false }))));
}
export default Description;
